<template>
    <section>
        <ui-breadcrumb title="Custom Bulk Message" :items="['Projects', 'SMS', 'Custom', 'Upload File']"></ui-breadcrumb>
        <div class="content">
            <form class="mb-5" action="" method="POST" @submit.prevent="uploadFile">
                <div class="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
                    <div class="row">
                        <div class="col-lg-12 pb-1">
                            <p class="font-w500"> The uploaded file should be a valid csv or excel file. After upload you will be able to compose your message </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>Contacts File</label>
                                <div class="custom-file">
                                    <input :class="{'is-invalid': formErrors.customFile}" @change="handleFile($event.target.name, $event.target.files)" type="file"
                                           class="custom-file-input" data-toggle="custom-file-input" id="contacts-file"
                                           name="customFile">
                                    <label class="custom-file-label" for="contacts-file">{{filePlaceholder}}</label>
                                    <div v-if="formErrors.customFile" :class="['invalid-feedback']">
                                        {{formErrors.customFile[0]}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12">
                            <div class="form-group float-right">
                                <button :disabled="loading" type="submit" :class="['btn', 'btn-hero', 'btn-outline-success']">
                                    <span class="si si-cloud-upload mr-2"></span>
                                    Upload File
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>

    export default {
        name: "UploadCustomBulkFile",
        data() {
            return {
                formErrors: [],
                hasError: false,
                loading: false,
                customFile: null,
                filePlaceholder: 'Choose your contacts file',
            }
        },
        methods: {
            uploadFile() {
                let $data = new FormData();
                    if (this.customFile instanceof File) {
                          $data.append('customFile', this.customFile, this.customFile.name);
                    }
                let project = this.$route.params.project;
                this.formErrors = [];
                this.loading = true;
                axios.post(`web/projects/${project}/sms/custom/file-upload`, $data, {
                    headers: {
                        'Content-Type': "multipart/form-data"
                    }
                }).then(response => {
                    this.$router.replace(`/projects/${project}/sms/custom/compose?req=${response.data.data}`);
                }).catch((error) => {
                    if(error.response && error.response.status === 422) {
                        this.formErrors = error.response.data.errors;
                        this.hasError = true;
                    }
                }).finally(() => this.loading = false)
            },

            handleFile(name, $file) {
                if($file[0] instanceof File) {
                    this.filePlaceholder = $file[0].name;
                    this.customFile = $file[0];
                }
            },
        }
    }
</script>

<style scoped>

</style>
